import { OnboardingStep } from '../../state/onboarding.types';
import { OnboardingAction } from './OnboardingBottomSheet.types';

export const ACTIONS: Record<OnboardingStep, OnboardingAction> = {
  [OnboardingStep.SECURITY_REVIEW]: OnboardingAction.OPEN_ONFIDO,
  [OnboardingStep.RETRY_VERIFICATION]: OnboardingAction.OPEN_ONFIDO,
  [OnboardingStep.REASSESSMENT]: OnboardingAction.OPEN_ONFIDO,
  [OnboardingStep.PENDING_VERIFICATION]: OnboardingAction.OPEN_ONFIDO,
  [OnboardingStep.SECURITY_REVIEW_MANUAL]: OnboardingAction.OPEN_CHAT,
  [OnboardingStep.VERIFICATION_IN_PROGRESS]: OnboardingAction.OPEN_CHAT,
  [OnboardingStep.MANUAL_VERIFICATION]: OnboardingAction.OPEN_CHAT,
  [OnboardingStep.DEPOSIT]: OnboardingAction.OPEN_DEPOSIT,
};
